import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './raffles.entity';

@Injectable({ providedIn: 'root' })
export class RafflesService extends AbstractService {
  protected override prefix = '/raffles';

  getRaffles(): Observable<ApiResponse.RafflesList> {
    return this.get('/active-list');
  }

  getUnclaimedRaffles(): Observable<ApiResponse.UnclaimedRewardsList> {
    return this.get('/unclaimed-rewards');
  }

  joinRaffle(raffleId: number): Observable<ApiResponse.ParticipantJoined> {
    return this.post<ApiResponse.ParticipantJoined>(`/${ raffleId }/join`, 
      { }, { throwError: false });
  }

  claimReward(raffleId: number, iterationId: number): Observable<ApiResponse.ParticipantJoined> {
    return this.post<ApiResponse.ParticipantJoined>(`/${ raffleId }/iterations/${ iterationId }/claim-reward`, 
      { }, { throwError: true });
  }

  getTopWinners(raffleId: number): Observable<ApiResponse.TopWinners>{
    return this.get<ApiResponse.TopWinners>(`/${ raffleId }/winners`, { throwError: true });
  }
}